import { useEventCallback } from '@cian/react-utils';

import { useSelector } from 'react-redux';

import { useApplicationContext } from 'shared/utils/applicationContext';
import { FC, useCallback, useEffect } from 'react';
import { ERegionalDistrictsStatus } from 'shared/types/geo';
import { LoadableErrorBoundary } from '../../../../../../packages/LoadableHelpers';
import { selectNeedRegionalDistrictsRequest, selectRegionalDistrictsStatus } from 'shared/selectors/geo';
import {
  loadRegionalDistricts,
  selectRegionalDistrict,
  syncRegionalDistricts,
} from 'shared/thunks/geo/regionalDistricts';
import { useAppDispatch } from 'shared/hooks';
import { RegionalDistrictsModalHeader } from '../../../../../../packages/GeoComponents';
import { GeoSuggestModalContent } from '../../../../../components/GeoSuggestModalContent';
import { useScrollToListElementById } from '../ModalContainer/hooks/useScrollToListElementById';
import { RegionalDistrictsContentContainerLoadable } from '../ModalContainer/RegionalDistrictsContentContainer';
import { RegionalDistrictsSearchContainer } from '../ModalContainer/RegionalDistrictsSearchContainer';

export const RegionalDistrictsModalContainerV2: FC = () => {
  const { logger } = useApplicationContext();
  const dispatch = useAppDispatch();

  const status = useSelector(selectRegionalDistrictsStatus);
  const needRequestData = useSelector(selectNeedRegionalDistrictsRequest);

  const { scrollToListElementById, listRefs } = useScrollToListElementById();

  const handleSearchSuggestSelect = useCallback(
    (id: number) => {
      dispatch(selectRegionalDistrict(id));
      scrollToListElementById(id);
    },
    [dispatch, scrollToListElementById],
  );

  const handleRetry = useEventCallback(() => RegionalDistrictsContentContainerLoadable.load());

  useEffect(() => {
    if (needRequestData) {
      dispatch(loadRegionalDistricts());
    }

    dispatch(syncRegionalDistricts());
  }, [dispatch, needRequestData]);

  return (
    <>
      <RegionalDistrictsModalHeader>
        {status === ERegionalDistrictsStatus.Ready && (
          <RegionalDistrictsSearchContainer onSelect={handleSearchSuggestSelect} />
        )}
      </RegionalDistrictsModalHeader>
      <LoadableErrorBoundary logger={logger} onRetry={handleRetry}>
        <GeoSuggestModalContent>
          <RegionalDistrictsContentContainerLoadable refs={listRefs} />
        </GeoSuggestModalContent>
      </LoadableErrorBoundary>
    </>
  );
};
